import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";

import { UploadDcuments, DynamicButtons, GenericDialog } from "./";
import { b64toUrl, GetMimeType } from "../utils";
import { useTranslation } from "react-i18next";
import VisorPDF from "./Visor/VisorPDF";

export const FullUploadFiles = (props) => {
  const formMethods = useForm({ mode: "onChange" });

  const [extension, setExtension] = useState(false);
  const [fileB64, setFileB64] = useState(null);
  const [fileUrl, setfileUrl] = useState(null);
  const { t } = useTranslation();

  let handleFileChange = (fileB64Response, extension) => {
    console.log(
      "handleFileChange***********************extension: ",
      extension,
      " fileB64Response: ",
      fileB64Response
    );
    setExtension(extension);
    if (fileB64Response == undefined || fileB64Response === null) {
      return;
    } else if (
      navigator.userAgent.match(/iPhone/i) &&
      (props.DocName == "TELMEX" || props.DocName == "IZZI")
    ) {
      props.onSendData(fileB64Response, extension);
      props.onClose();
    } else {
      setFileB64(fileB64Response);
    }
  };

  console.log("ppropsropsprops 00", props.ExtensionsDoc);

  useEffect(() => {
    if (fileB64 != undefined && fileB64 != null && fileB64 != "") {
      async function fetchData() {
        const blobUrl = await b64toUrl(`${GetMimeType(extension)},${fileB64}`);
        console.log("URL Blob: ", blobUrl);
        setfileUrl(blobUrl);
      }
      fetchData();
    }
  }, [fileB64]);

  const handleContinue = () => {
    console.log("handleContinue new event");
    props.onSendData(fileB64, extension);
    props.onClose();
  };

  const handleCancel = () => {
    console.log("handleCancel new event");
    props.onClose();
  };

  const handleUpload = () => {
    console.log("handleUpload new event");
    setFileB64(null);
  };

  return (
    <GenericDialog
      onClose={props.onClose}
      open={props.open}
      title={
        props.DocName == "Fotografía" || props.DocName == "Fotografia"
          ? `${t("document_upload_photo")} - ${props.DocName}`
          : `${t("document_upload_doc")} - ${props.DocName}`
      }
      content={
        <Box
          sx={{
            display: "flex",
            position: "relative",
            height: "67vh",
            flexDirection: "column",
          }}
        >
          <FormProvider {...formMethods}>
            {console.log("propsprops", props)}
            <Box
              sx={{
                padding: "0.8em 0.9em 0.5em 0.9em",
              }}
            >
              <Typography variant="subtitle1">
                {props.DocName == "Fotografía" || props.DocName == "Fotografia"
                  ? t("document_picture_size")
                  : t("document_upload_verification")}
              </Typography>
            </Box>
            <Box
              sx={{
                padding: "0.8em 0.9em 0.5em 0.9em",
                overflowY: "auto",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                {renderViewer(
                  fileB64,
                  fileUrl,
                  handleFileChange,
                  props.setInitChangeFile,
                  props.ExtensionsDoc,
                  extension
                )}
              </Box>
            </Box>
          </FormProvider>
        </Box>
      }
      actions={
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <DynamicButtons
            marginTop={20}
            marginBottom={5}
            zIndex={200}
            buttons={[
              ...(fileB64
                ? [
                    {
                      id: "continue",
                      text: t("document_upload"),
                      onClick: handleContinue,
                      variant: "contained",
                      disabled: false,
                      paddingX: 10,
                    },
                    {
                      id: "cargar",
                      text: t("document_select"),
                      onClick: handleUpload,
                      variant: "outlined",
                      disabled: false,
                      paddingX: 5,
                    },
                  ]
                : [
                    {
                      id: "cancel",
                      text: t("general_cancel"),
                      onClick: handleCancel,
                      variant: "outlined",
                      disabled: false,
                      paddingX: 10,
                    },
                  ]),
            ]}
          />

          {/* {fileB64 != null && fileB64 != undefined && fileB64 != "" ? (
            <Buttons
              marginTop={0}
              ConfirmButtonText={t("document_upload")}
              onClickConfirm={() => {
                props.onSendData(fileB64, extension);
                props.onClose();
              }}
              CancelButtonText={t("document_select")}
              onClickCancel={() => {
                setFileB64(null);
              }}
            />
          ) : (
            <Buttons
              ConfirmButtonText={t("general_cancel")}
              onClickConfirm={props.onClose}
            />
          )} */}
        </Box>
      }
    />
  );
};

const renderViewer = (
  fileB64,
  fileUrl,
  handleChange,
  setInitChangeFile,
  extensionsDoc,
  extension = ".pdf"
) => {
  console.log(
    "extensionfileUrl, fileB64, handleChange ",
    extension,
    fileUrl,
    extensionsDoc?.includes(extension)
  );
  if (fileB64 === null) {
    return (
      <UploadDcuments
        setInitChangeFile={setInitChangeFile}
        ExtensionsDoc={extensionsDoc}
        initLoadChange={true}
        onChange={handleChange}
        onClear={fileB64 == null ? true : false}
      />
    );
  } else if (fileUrl == null) {
    return <span>Espere...</span>;
  } else if (
    fileUrl != null &&
    extensionsDoc?.includes(extension) &&
    (extension == "png" || extension == "jpg" || extension == "jpeg")
  ) {
    return <img src={fileUrl} alt="image" />;
  } else if (extensionsDoc?.includes(extension) && extension == "pdf") {
    return <VisorPDF pdfUrl={fileUrl} pdfName={"Document"} height={"50vh"} />;
  }
};
